(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["benefits-US"] && !Shopify.designMode) return;
  try {
    

$benefitsCarousel = false;
    function benefitsCarouselCheck(){    
        if($(window).width() < 767){
            if(!$benefitsCarousel){
                
                $(".benefits .desktop").removeClass('desktop').slick({
                    dots: true,
                    arrows: false,
                    autoplay: true,
                    slidesToShow: 1,
                    slidesToScroll: 1
                });
                $benefitsCarousel = true;
            }
        } else if($(window).width() > 767){
            if($benefitsCarousel){
                $('.benefits .slick-initialized').slick('unslick').addClass('desktop');
                $benefitsCarousel = false;
            }
        }
    };

    $(document).ready(function(){
        benefitsCarouselCheck();
    });
    $(window).on('resize', function(){
        benefitsCarouselCheck();
    });



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bundles"]) return;
  try {
    
  let maxSaving = 0;
  $('.bundle-heading__offer_3cl').each(function (idx, elem) {
    const saving = Number(
      $(elem)
        .text()
        .replace(/[^\d.-]/g, '')
    );
    maxSaving = maxSaving > saving ? maxSaving : saving;
  });
  $('#max-saving').text(maxSaving);

  $('.slct').change(function () {
    var product_id = $(this).find(':selected').data('product_id');
    var variant_id = $(this).find(':selected').data('variant_id');
    var variant_price = $(this).find(':selected').data('variant_price');
    var variant_compare_price = $(this).find(':selected').data('variant_compare_price');
    var save = $(this).find(':selected').data('save_up_to');
    $('.active_variant').val($(this).find(':selected').data('variant_id'));

    installment = variant_price;
    //installment = parseInt(installment.replace(/[^\d]/g, ''), 10);
    installment = parseFloat(installment.replace('£', '').replace(',', ''));

    $('.' + product_id + ' .product_current_price').text(variant_price);
    $('.' + product_id + ' .product_original_price').text(variant_compare_price);
    $('.' + product_id + ' .product_savings_text_3VN').text('Save ' + save);
    $('.' + product_id + ' .affirm-ala-price').text('£' + parseFloat(installment / 12).toFixed(2));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["compare-values"] && !Shopify.designMode) return;
  try {
    
  $compareSlickCarousel = false;
  function compareCarouselCheck() {
    if ($(window).width() < 767) {
      if (!$compareSlickCarousel) {
        $('#compare_value_props_section .carousel').slick({
          dots: true,
          arrows: false,
          autoplay: true,
          slidesToShow: 1,
          slidesToScroll: 1,
        });
        $compareSlickCarousel = true;
      }
    } else if ($(window).width() > 767) {
      if ($compareSlickCarousel) {
        $('#compare_value_props_section .carousel').slick('unslick');
        $compareSlickCarousel = false;
      }
    }
  }

  $(document).ready(function () {
    compareCarouselCheck();
  });
  $(window).on('resize', function () {
    compareCarouselCheck();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-collection"] && !Shopify.designMode) return;
  try {
    

  $customCollectionSlickCarousel = false;
  function customCollectionCarouselCheck(){    
    if($(window).width() < 767){
      if(!$customCollectionSlickCarousel){
        $("#custom-content-container-section .carousel").slick({
          dots: true,
          arrows: false,
          autoplay: true,
          slidesToShow: 1,
          slidesToScroll: 1
        });
        $customCollectionSlickCarousel = true;
      }
    } else if($(window).width() > 767){
      if($customCollectionSlickCarousel){
        $('#custom-content-container-section .carousel').slick('unslick');
        $customCollectionSlickCarousel = false;
      }
    }
  };

  $(document).ready(function(){
    customCollectionCarouselCheck();
  });
  $(window).on('resize', function(){
    customCollectionCarouselCheck();
  });



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customer-reviews-US"] && !Shopify.designMode) return;
  try {
    
/*
$("#home_customer_reviews_section .slick-track").slick({
    dots: false,
    arrows: true,
    autoplay: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    pauseOnHover: true
});
*/

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["duvet-values"] && !Shopify.designMode) return;
  try {
    
  $duvetSlickCarousel = false;
  function duvetCarouselCheck() {
    if ($(window).width() < 767) {
      if (!$duvetSlickCarousel) {
        $('#duvet_value_props_section .carousel').slick({
          dots: true,
          arrows: false,
          autoplay: true,
          slidesToShow: 1,
          slidesToScroll: 1,
        });
        $duvetSlickCarousel = true;
      }
    } else if ($(window).width() > 767) {
      if ($duvetSlickCarousel) {
        $('#duvet_value_props_section .carousel').slick('unslick');
        $duvetSlickCarousel = false;
      }
    }
  }

  $(document).ready(function () {
    duvetCarouselCheck();
  });
  $(window).on('resize', function () {
    duvetCarouselCheck();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-custom-content-update"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    let $questionTitles = document.getElementsByClassName('custom-faq-question');
    for (let $title of $questionTitles) {
      $title.addEventListener('click', () => {
        let $parent = $title.parentElement;
        let $answer = $parent.getElementsByClassName('custom-faq-answer')[0];
        $answer.classList.toggle('custom-faq-answer-active');
        if ($answer.classList.contains('custom-faq-answer-active'))
          $answer.style.maxHeight = $answer.scrollHeight + 'px';
        else {
          $answer.style.maxHeight = 0;
        }
        $title.classList.toggle('active-custom-faq-question');
      });
    }
    let $secondHalfSections = document.getElementsByClassName('second-half-section');
    function hideMoreThan3Questions(content) {
      if (content === 'all-sections') {
        for (let $section of $secondHalfSections) {
          if ($section.childElementCount > 4) {
            let $customQuestionContainers = $section.getElementsByClassName('custom-question-container');
            counter = 0;
            for (let $container of $customQuestionContainers) {
              counter++;
              if (counter > 3) {
                $container.classList.add('custom-question-container-hide');
                if ($container.classList.contains('custom-question-container-hide')) $container.style.maxHeight = 0;
                else {
                  for (let child of $container.children) {
                    $container.style.maxHeight += child.scrollHeight;
                  }
                  $container.style.maxHeight += 'px';
                }
              }
            }
          }
        }
      } else {
        if (content.childElementCount > 4) {
          let $customQuestionContainers = content.getElementsByClassName('custom-question-container');
          let counter = 0;
          for (let $container of $customQuestionContainers) {
            counter++;
            if (counter > 3) {
              $container.classList.add('custom-question-container-hide');
              if ($container.classList.contains('custom-question-container-hide')) $container.style.maxHeight = 0;
              else {
                for (let child of $container.children) {
                  $container.style.maxHeight += child.scrollHeight;
                }
                $container.style.maxHeight += 'px';
              }
            }
          }
        }
      }
    }
    hideMoreThan3Questions('all-sections');

    let $faqSectionButtons = document.getElementsByClassName('custom-faq-section-button');
    for (let $button of $faqSectionButtons) {
      $button.addEventListener('click', (evt) => {
        $chosenSecondHalfSection = document.getElementsByClassName(`second-half-section ${evt.target.classList[1]}`)[0];
        let $childrenContainers = $chosenSecondHalfSection.children;
        hideMoreThan3Questions('all-sections');
        if ($button.classList.contains('active-section-button')) {
          hideMoreThan3Questions($chosenSecondHalfSection);
          $button.textContent = 'see all';
          $button.classList.remove('active-section-button');
        } else {
          for (let $notActiveButton of $faqSectionButtons) {
            $notActiveButton.classList.remove('active-section-button');
            $notActiveButton.textContent = 'see all';
          }
          $button.classList.add('active-section-button');
          $button.textContent = 'see less';
          for (let $container of $childrenContainers) {
            if ($container.classList.contains('custom-question-container')) {
              $container.classList.remove('custom-question-container-hide');
              if ($container.classList.contains('custom-question-container-hide')) {
                $container.style.maxHeight = 0;
              } else {
                let heigth = 0;
                for (let child of $container.children) {
                  heigth += child.scrollHeight;
                }
                $container.style.maxHeight = heigth + 'px';
              }
            }
          }
        }
      });
    }
    document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
      anchor.addEventListener('click', function (e) {
        e.preventDefault();
        document.querySelector(this.getAttribute('href')).scrollIntoView({
          behavior: 'smooth',
        });
      });
    });
    //adaptive
    let $customQuestionSectionsTitleAdp = document.getElementsByClassName('custom-question-section-title-adp');
    for (let $section of $customQuestionSectionsTitleAdp) {
      $section.addEventListener('click', () => {
        $section.classList.toggle('custom-question-section-title-adp-active');
        let $container = $section.nextElementSibling;
        $container.classList.toggle('custom-question-container-adp-active');
      });
    }
    let $customQuestionsAdp = document.querySelectorAll('.custom-question-adp');
    for (const $question of $customQuestionsAdp) {
      $question.addEventListener('click', () => {
        $question.classList.toggle('active');
        let $title = $question.children[0];
        $title.classList.toggle('custom-question-title-adp-active');
        let $answer = $question.children[1];
        $answer.classList.toggle('custom-question-answer-adp-active');
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul')
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-site-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {

      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const scrollBottom = window.pageYOffset + window.innerHeight || document.documentElement.scrollTop + window.innerHeight;

      var body = document.body,
      html = document.documentElement;

      var height = Math.max( body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight );
      //console.group();
      //console.log(height)
      //console.log(scrollBottom)
      //console.log(document.querySelector('body').getBoundingClientRect().height)
      //console.groupEnd();

      if(scrollBottom >= document.querySelector('body').getBoundingClientRect().height){
        document.querySelector('.shopify-site-header').style.display = 'none';
      }else{
        document.querySelector('.shopify-site-header').style.display = 'block';
      }

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom && scrollBottom <= height) {
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }


      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeDropdowns();
      this.hideOverlay();
      //this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      this.resetDropdowns();
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      this.resetDropdowns();
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }

    closeDropdowns() {
      this.dropdowns = this.dropdowns || this.header.querySelectorAll('.header__dropdown-container');
      this.dropdowns.forEach(dropdown => dropdown.classList.add('header__dropdown-container-closed'));
    }

    hideOverlay() {
      this.overlay = this.overlay || this.header.querySelector('.header__background-overlay');
      this.overlay.style.opacity = '0';
      this.overlay.style.visibility = 'hidden';
    }

    resetDropdowns(){
      this.dropdowns = this.dropdowns || this.header.querySelectorAll('.header__dropdown-container');
      this.dropdowns.forEach(dropdown => dropdown.classList.remove('header__dropdown-container-closed'));
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-hero"] && !Shopify.designMode) return;
  try {
    
  jQuery(document).ready(function () {
    jQuery('#home_banner_video_btn').click(function (e) {
      e.preventDefault();
      e.stopPropagation();
      jQuery('body').addClass('show_modal');
      jQuery('#homeVimeo').attr('src', videoURL + '?autoplay=1');
    });
    jQuery('div#modal_dialog').click(function () {
      jQuery('body').removeClass('show_modal');
      jQuery('#homeVimeo').attr('src', '');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-summary"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener(
        'change',
        debounce(event => {
          const body = JSON.stringify({ note: event.target.value });
          fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
        }, 300)
      );
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-legacy"]) return;
  try {
    
  /* class ProductModal extends ModalDialog {
    constructor() {
      super();
    }
    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal); */

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter-US"] && !Shopify.designMode) return;
  try {
    

$('#home_newsletter_section input').css('width', '100%');
$('#home_newsletter_section input').css('border', '1px');
$('#home_newsletter_section button').css('height', '38px');



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["protector-values"] && !Shopify.designMode) return;
  try {
    
  $protectorSlickCarousel = false;
  function protectorCarouselCheck() {
    if ($(window).width() < 767) {
      if (!$protectorSlickCarousel) {
        $('#protector_value_props_section .carousel').slick({
          dots: true,
          arrows: false,
          autoplay: true,
          slidesToShow: 1,
          slidesToScroll: 1,
        });
        $protectorSlickCarousel = true;
      }
    } else if ($(window).width() > 767) {
      if ($protectorSlickCarousel) {
        $('#protector_value_props_section .carousel').slick('unslick');
        $protectorSlickCarousel = false;
      }
    }
  }

  $(document).ready(function () {
    protectorCarouselCheck();
  });
  $(window).on('resize', function () {
    protectorCarouselCheck();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews-old"] && !Shopify.designMode) return;
  try {
    
    $(".reviews_1eN .slick-track").slick({
        dots: false,
        arrows: true,
        autoplay: true,
        slidesToShow: 1,
        slidesToScroll: 1
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["topMenuCheckout"]) return;
  try {
    

$('#cart-icon').click(function(){
  window.location.href = "/cart";
}); 


  } catch(e) { console.error(e); }
})();
})();
